import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

// ─── Login ────────────────────────────────────────────────────────────────────
export const loginUser = createAsyncThunk(
    "auth/loginUser",
    async ({ email, password, remember }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("api/auth/login", { email, password, remember });

            if (response.data) {
                // If the API returns 2xx but success: false, treat as error
                if (response.data.success === false) {
                    return rejectWithValue(response.data.message || "Login failed");
                }

                const user = response.data.data?.user || response.data.user;
                if (user) return user;

                // Fallback: fetch /me if user not in response
                try {
                    const meRes = await axiosInstance.get("api/auth/me");
                    if (meRes.data?.user) return meRes.data.user;
                } catch (meError) {
                    console.warn("Fallback /me fetch failed:", meError);
                }
                return rejectWithValue("Login succeeded but failed to retrieve user details.");
            }
            return rejectWithValue("Invalid response from server");
        } catch (error) {
            // axiosInstance already standardizes the error message into error.message
            // But we also check for nested data message just in case
            const message = error.response?.data?.message || error.message || "Login failed";
            return rejectWithValue(message);
        }
    }
);

// ─── Register ─────────────────────────────────────────────────────────────────
export const registerUser = createAsyncThunk(
    "auth/registerUser",
    async (userData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("api/auth/register", userData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// ─── Forgot Password ──────────────────────────────────────────────────────────
export const requestPasswordReset = createAsyncThunk(
    "auth/requestPasswordReset",
    async ({ email }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("api/auth/request-password-reset-otp", { email });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// ─── Reset Password ───────────────────────────────────────────────────────────
export const verifyPasswordResetOtp = createAsyncThunk(
    "auth/verifyPasswordResetOtp",
    async ({ email, otp }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("api/auth/verify-password-reset-otp", { email, otp });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// ─── Reset Password ───────────────────────────────────────────────────────────
export const resetPassword = createAsyncThunk(
    "auth/resetPassword",
    async ({ resetToken, newPassword, confirmPassword }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("api/auth/reset-password", {
                resetToken,
                newPassword,
                confirmPassword,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
